<p class="text-center mt-5">
  <small>{{ model()?.vatRegNo }} {{ model()?.companyRegNo }} {{ model()?.eoriNo }} {{ model()?.trademark }}</small>
</p>
